import { GovPlanSecretaryProject } from "../../model/project";
import DragAndDropTable from "./dnd-table";

export type GovPlanProjectDetailsProps = {
    project: GovPlanSecretaryProject;
};

export const GovPlanProjectRoadmapList = ({
    project,
}: GovPlanProjectDetailsProps) => {
    return <DragAndDropTable project={project} />;
};
